<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5> {{ $t('Filters') }} </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2">
          <label>{{ $t('Category') }}</label>
          <v-select multiple :close-on-select="false" label="name" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :value="categoriesFilter" :options="categoriesOptions.map((i) => ({ id: i, name: $t(i) }))" class="w-100"
            :reduce="val => val.id" @input="(val) => $emit('update:categoriesFilter', val)" />
        </b-col>

        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Owners') }}</label>
          <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :value="ownersFilter"
            label="name" :options="ownersOptions" class="w-100" :reduce="val => val.id"
            @input="(val) => $emit('update:ownersFilter', val)" />
        </b-col>
              </b-row>
              <b-row>
                <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('types') }}</label>
          <v-select multiple :close-on-select="false"  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :value="typeFilter"
            :getOptionLabel="t => t.name" :options="typesOptions" class="w-100" :reduce="val => val.id"
            @input="(val) => $emit('update:typeFilter', val)" />
        </b-col>

        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Contracts') }}</label>
          <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :value="contractsFilter"
            :getOptionLabel="c => c.name" :options="contractsOptions" class="w-100" :reduce="val => val.id"
            @input="(val) => $emit('update:contractsFilter', val)" />
        </b-col>

        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Support Devices') }}</label>
          <v-select  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 

             :getOptionLabel="c =>$t( c.name)"
             
             :options="[{id:'all',name:'all'},{id:'true',name:'Support Devices'},{id:'false',name:'Not Support devices'}]" 
             class="w-100" 
             :reduce="val => val.id"
            @input="(val) => $emit('update:isSupportFilter', val)" />
        </b-col>
              </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton, VBToggle, BCollapse
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow, BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {

    categoriesFilter: {
      type: Array,
      default: [],
    },
    typeFilter: {
      type: Array,
      default: [],
    },
    groupFilter: {
      type: [Number, null],
      default: null,
    },
    contractsFilter: {
      type: Array,
      default: [],
    },
    ownersFilter: {
      type: [Array],
      default: [],
    },


    categoriesOptions: {
      type: Array,
      required: true,
    },
    typesOptions: {
      type: Array,
      required: true,
    },
    groupsOptions: {
      type: Array,
      required: true,
    },
    ownersOptions: {
      type: Array,
      required: true,
    },
    contractsOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
